module.exports = __webpack_public_path__ + "static/media/preplay-up-arrow-white.e6ecc28a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preplay-up-arrow-white.svg
// module id = ./src/assets/images/preplay-up-arrow-white.svg
// module chunks = 0